import React, { useEffect } from 'react';
import './pb2025.css';
import { pb2025 } from '../../json/pb2025';

const Pb2025 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Padrones de Beneficiarios 2025</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
             
              <div style={{ textAlign: 'left' }}>

              <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Subsecretaría de Inclusión y Desarrollo</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                     <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_SVV_2o_T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Subsidio al Servicio de Verificación Vehicular Segundo Trimestre 2025
                      </a>
                    </strong>
                    <br /> 
                  </li>
                  <li>
                     <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_SVV_3T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Subsidio al Servicio de Verificación Vehicular Tercer Trimestre 2025
                      </a>
                    </strong>
                    <br /> 
                  </li>
                  <li>
                     <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/Variables_PUB_Verificentros_4T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Subsidio al Servicio de Verificación Vehicular Cuarto Trimestre 2025 
                      </a>
                    </strong>
                    <br /> 
                  </li>
                  <li>
                     <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/Variables_PUB_MT_4T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Bienestar de Madres Trabajadoras Cuarto Trimestre de 2025 
                      </a>
                    </strong>
                    <br /> 
                  </li>
                  <li>
                     <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/Variables_PUB_ByD_4T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Programa Bienestar y Desarrollo Cuarto Trimestre de 2025 
                      </a>
                    </strong>
                    <br /> 
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Subsecretaría de Desarrollo Social y Humano</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_DI_3t_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Programa Desarrollo Inclusivo Tercer Trimestre 2025 
                      </a>
                    </strong>
                    <br />                     
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_Des_Inc_4oT_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Programa Desarrollo Inclusivo Cuarto Trimestre 2025 
                      </a>
                    </strong>
                    <br />                     
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_Cuidadores_Dis_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Programa Bienestar de Personas Cuidadoras de Personas con Discapacidad 2025 
                      </a>
                    </strong>
                    <br />                     
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Subsecretaría de Participación Social y Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                  <strong>
                      <a href='/assets/pdfs/PUB_PFDPSB.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Programa de Fomento a la Participción Social Para el Bienestar 2025
                      </a>
                    </strong>
                    <br />   
                  </li>
                  
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Dirección General de Atención al Migrante</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                  <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_Migrantes_1er_T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                     
                  </li>

                   <li>
                  <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_Migrantes_2o_T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                     
                  </li>

                  <li>
                  <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_Migrantes_3T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                     
                  </li>

                   <li>
                  <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_Migrantes_4T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                     
                  </li>

                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Dirección General de Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/Padron_DGFA_1erT_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                   <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/Padron_DGFA_2oT_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                  <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2025/PUB_FA_3T_2025.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                     
                  </li>
                   <li>
                  <strong>
                      <a href='/assets/pdfs/DGFA_4T.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />   
                  </li> 
                </ul>
                <a href='' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Estadisticas PUB 4to Trimestre 2025</h5>
                </a>
                {/* Añade el resto de los bloques aquí */}
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Pb2025;
